import axios from 'axios'
const REACT_APP_API_URL = process.env.REACT_APP_API_URL

export const changePassword = async ({newPassword, validator}) => {

  try {
    const url = `${REACT_APP_API_URL}/token-provider`
    const headers = {
      'Authorization': localStorage.getItem('dashboard_access_token') ? `Bearer ${localStorage.getItem('dashboard_access_token')}` : validator,
      'Content-Type': 'application/json'
    }
    const body = {
      "type": "reset_password",
      "email": localStorage.getItem('dashboard_logged_user'),
      "password": newPassword
    }
    const response = await axios.post(url, {...body}, {headers: headers})
    return response
  } catch (error) {
    const {response} = error
    return response
  }
}


